import {
  IRequirementResponse,
  IRequirementUpdateRequest
} from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";
import { Nullable } from "../../types/utilities";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";

export type WSRequirementUpdateRequest = Nullable<IRequirementUpdateRequest>;

export const updateRequirement = async (
  id: string,
  payload: WSRequirementUpdateRequest,
  orgPayerId: string | undefined
): Promise<IRequirementResponse> => {
  const response = await servicePayments.patch(
    `/requirement/${id}`,
    payload,

    extendConfigWithXWingspanUserHeader({}, orgPayerId)
  );
  return response.data;
};
